import seathruApi from '@src/lib/axios';

// GET
// /api/common/countries
export const getCountries = async () => {
  const { data } = await seathruApi({
    url: '/api/common/countries',
    method: 'get',
  });

  return data;
};
